import React, { Component } from 'react';
import '../../App.css';

import fruit from '../../img/fruit.png'
import fish from '../../img/fish.png'
import roses from '../../img/roses.png'

class products extends Component {
  render() {
    return (
      <div className="products">
          <span>Наши Продукты</span><br/>
          <div className="three-items">
            <div className="item">
              <img src={fruit} alt=""/>
              <span><a href="/pioricost-fruit">
                <button>знать</button>
                </a></span>
            </div>
            <div className="item">
              <img src={fish} alt=""/>
              <span><a href="/pioricost-fruit">
                <button disabled>скоро</button>
                </a></span>
            </div>
            <div className="item">
              <img src={roses} alt=""/>
              <span><a href="/pioricost-fruit">
                <button disabled>скоро</button>
                </a></span>
            </div>
          </div>
      </div>
    );
  }
}

export default products;


// WEBPACK FOOTER //
// ./src/components/ru-home/products.js